{
  "header": {
    "title": "Bibliothèque de questions",
    "description": "Gérez vos catégories de feedback et questions",
    "addCategoryButton": "Ajouter une catégorie"
  },
  "searchInput": {
    "placeholder": "Rechercher des questions"
  },
  "delete": {
    "title": "Supprimer la catégorie",
    "description": "Êtes-vous sûr de vouloir supprimer cette catégorie ? Cette action est irréversible et toutes les questions et réponses associées seront définitivement supprimées.",
    "deleteButton": "Supprimer la catégorie",
    "cancelButton": "Annuler"
  },
  "translationOverview": {
    "title": "Traduction dans d'autres langues",
    "description": "Nous utilisons la traduction par IA, donc le résultat peut contenir des erreurs"
  },
  "detailsPage": {
    "header": {
      "backButton": "Retour aux catégories de questions",
      "questionsCount": "{{questionsCount}} questions",
      "addQuestionButton": "Ajouter une question"
    },
    "searchInput": {
      "placeholder": "Rechercher des questions"
    },
    "sortDropdown": {
      "triggerLabel": "Trier par",
      "options": {
        "questionQuantity": "Nombre de questions",
        "fromNewestToOldest": "Du plus récent au plus ancien",
        "fromOldestToNewest": "Du plus ancien au plus récent"
      }
    },
    "delete": {
      "title": "Supprimer la question",
      "description": "Êtes-vous sûr de vouloir supprimer cette question ? Cette action est irréversible et toutes les réponses associées seront définitivement supprimées.",
      "deleteButton": "Supprimer la question",
      "cancelButton": "Annuler"
    },
    "translationOverview": {
      "title": "Traduction dans d'autres langues",
      "description": "Nous utilisons la traduction par IA, donc le résultat peut contenir des erreurs"
    }
  }
}
